import React from 'react';
import T from 'prop-types';
// styles
import classnames from 'classnames/bind';
import styles from './Line.mod.css';

const cx = classnames.bind(styles);

const Line = ({ className = '', solid, type = 'line', ...otherProps }) => (
  <svg
    viewBox="0 0 160 100"
    xmlns="http://www.w3.org/2000/svg"
    strokeDasharray={solid ? '' : '7, 7'}
    className={cx(type, className, { solid })}
    {...otherProps}>
    {type === 'curve' && (
      <path
        d="M0 0 C 0 100, 160 100, 160 0"
        stroke="#56CCF2"
        fill="transparent"
        strokeWidth="4"
      />
    )}
    {type === 'line' && (
      <line
        x1="0"
        y1="50%"
        x2="100%"
        y2="50%"
        stroke="#56CCF2"
        strokeWidth="4"
        strokeDasharray={solid ? '' : '12'}
      />
    )}
  </svg>
);

Line.propTypes = {
  className: T.string,
  type: T.oneOf(['line', 'curve']),
  solid: T.bool
};

export default Line;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/components/Line.jsx